import { LineChart } from "@mui/x-charts";
import React, { useEffect, useState } from "react";
import { getLast7Days } from "../../../../utilities/utilities";
import { toast } from "react-toastify";

const RevenueChart = ({ graphData }) => {
  const [series, setSeries] = useState([]);


  useEffect(() => {
    if (!graphData && !graphData?.length) {
      return;
    }

    const newSeries = graphData.map((item, ind) => {
      return item?.totalRevenue;
    });



    if (newSeries.reduce((prev, next) => prev + next, 0) === 0) {
      return;
    }

    // if (newSeries.length !== 7) {
    //   return toast.error("wrong graph data");
    // }

    setSeries(newSeries);
  }, [graphData]);
  

  return (
    <LineChart
    
      xAxis={[{ scaleType: "point", data:getLast7Days() }]}
colors={[
  "#e4887e"
]}
      series={[
        {
          data: series,
          area: true,
        },
      ]}
      width={800}
      height={400}
    />
  );
};

export default RevenueChart;
